var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('button',{staticClass:"ZoomPlus",on:{"mouseup":function($event){return _vm.Zoom(1)}}},[_c('div',{staticClass:"Icon PlusIcon"})]),_c('button',{staticClass:"ZoomMinus",on:{"mouseup":function($event){return _vm.Zoom(-1)}}},[_c('div',{staticClass:"Icon MinusIcon"})]),_c('div',{staticClass:"borderObj"})])
}
var staticRenderFns = []

export { render, staticRenderFns }